/* DRION — interakcje: nagłówek i menu, tło za kursorem/palcem, przechył drona w hero, tryby lot/drift,
   wybór koloru, animacje przy przewijaniu, własny „Kup teraz”. Bez bibliotek. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ROOT = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Nagłówek: menu na telefonie, „szkło” po przewinięciu, koszyk otwiera wysuwany koszyk Horizon. */
  function initHeader(root) {
    const header = root.querySelector('[data-dr-header]');
    if (!header || header.dataset.drReady) return;
    header.dataset.drReady = '1';
    const burger = header.querySelector('[data-dr-burger]');
    const drawer = header.querySelector('[data-dr-drawer]');
    const setMenu = (open) => {
      if (!burger || !drawer) return;
      const was = !drawer.hidden;
      drawer.style.setProperty('--dr-drawer-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
      drawer.hidden = !open;
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', (open ? burger.dataset.labelClose : burger.dataset.labelOpen) || 'Menu');
      document.documentElement.toggleAttribute('scroll-lock', open);
      header.classList.toggle('is-open', open);
      [document.getElementById('MainContent'), document.querySelector('.page-wrapper > footer')].forEach((el) => { if (el) el.inert = open; });
      if (open) drawer.querySelector('a')?.focus();
      else if (was) burger.focus();
    };
    // Horizon na komputerze przewija .page-wrapper, nie okno
    const pw = document.querySelector('.page-wrapper');
    let scrolled = null;
    const onScroll = () => { const s = Math.max(scrollY, pw ? pw.scrollTop : 0) > 8; if (s !== scrolled) { scrolled = s; header.classList.toggle('is-scrolled', s); } };
    onScroll();
    addEventListener('scroll', onScroll, { passive: true });
    pw?.addEventListener('scroll', onScroll, { passive: true });
    pw?.addEventListener('scroll', syncStickyH, { passive: true });
    burger?.addEventListener('click', () => setMenu(drawer.hidden));
    drawer?.addEventListener('click', (e) => { if (e.target.closest('a')) setMenu(false); });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer && !drawer.hidden) setMenu(false); });
    matchMedia('(min-width: 990px)').addEventListener('change', (e) => { if (e.matches) setMenu(false); });

    const cartLink = header.querySelector('[data-dr-cart]');
    cartLink?.addEventListener('click', (e) => {
      // wysuwany koszyk Horizon: <theme-drawer id="cart-drawer"> (na stronie /cart go nie ma → zwykły link)
      const d = document.getElementById('cart-drawer');
      if (d && typeof d.open === 'function') { e.preventDefault(); d.open(); }
    });
    const count = header.querySelector('[data-dr-cart-count]');
    const refresh = () => fetch(ROOT() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => { if (count) { count.textContent = c.item_count; count.hidden = c.item_count === 0; } })
      .catch(() => {});
    let cartT = 0;
    const onCart = () => { clearTimeout(cartT); cartT = setTimeout(refresh, 50); };
    ['cart:update', 'shopify:cart:lines-update'].forEach((n) => document.addEventListener(n, onCart));
    addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
  }

  /* Tło: niebieska poświata podąża za kursorem / palcem. */
  function initSky() {
    const sky = document.getElementById('dr-sky');
    if (!sky || sky.dataset.drReady || reduce || sky.dataset.react !== 'true') return;
    sky.dataset.drReady = '1';
    const spot = sky.querySelector('.dr-sky__spot');
    let raf = 0, x = innerWidth * 0.7, y = innerHeight * 0.3, tx = x, ty = y, idle = 0;
    const loop = () => {
      x += (tx - x) * 0.12; y += (ty - y) * 0.12;
      spot.style.setProperty('--x', x.toFixed(1) + 'px'); spot.style.setProperty('--y', y.toFixed(1) + 'px');
      raf = Math.abs(tx - x) + Math.abs(ty - y) > 0.5 ? requestAnimationFrame(loop) : 0;
    };
    addEventListener('pointermove', (e) => {
      tx = e.clientX; ty = e.clientY; sky.classList.add('is-live');
      clearTimeout(idle); idle = setTimeout(() => sky.classList.remove('is-live'), 2500);
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
  }

  /* Hero: lekki przechył drona za kursorem (tylko mysz). */
  function initTilt(root) {
    root.querySelectorAll('[data-dr-tilt]').forEach((el) => {
      if (el.dataset.drReady || reduce) return;
      el.dataset.drReady = '1';
      const box = el.closest('.dr-hero') || el;
      box.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse') return;
        const r = box.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--rx', (px * 14).toFixed(2) + 'deg');
        el.style.setProperty('--ry', (-py * 10).toFixed(2) + 'deg');
      });
      box.addEventListener('pointerleave', () => { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
    });
  }

  /* Tryby lot / drift: przełącznik + przesunięcie palcem po zdjęciu. */
  function initModes(root) {
    root.querySelectorAll('[data-dr-modes]').forEach((sec) => {
      if (sec.dataset.drReady) return;
      sec.dataset.drReady = '1';
      const tabs = [...sec.querySelectorAll('[data-dr-tab]')];
      const panels = [...sec.querySelectorAll('[data-dr-panel]')];
      const bar = sec.querySelector('.dr-tabs');
      let cur = 0;
      const go = (i, focus) => {
        cur = (i + tabs.length) % tabs.length;
        tabs.forEach((t, j) => { t.setAttribute('aria-selected', String(j === cur)); t.tabIndex = j === cur ? 0 : -1; });
        panels.forEach((p, j) => { p.hidden = j !== cur; p.classList.toggle('is-in', j === cur); });
        if (bar) bar.dataset.active = String(cur);
        if (focus) tabs[cur].focus();
      };
      tabs.forEach((t, j) => {
        t.addEventListener('click', () => go(j));
        t.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1, true); }
        });
      });
      panels.forEach((p) => {
        const m = p.querySelector('.dr-modes__media');
        let x0 = null;
        m?.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
        m?.addEventListener('pointerup', (e) => { if (x0 === null) return; const dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); });
        m?.addEventListener('pointercancel', () => { x0 = null; });
      });
      go(0);
    });
  }

  /* Wybór koloru: zdjęcie, nazwa, cena, wariant w formularzu i link do strony produktu. */
  function initColors(root) {
    root.querySelectorAll('[data-dr-colors]').forEach((sec) => {
      if (sec.dataset.drReady) return;
      sec.dataset.drReady = '1';
      const chips = [...sec.querySelectorAll('[data-dr-chip]')];
      const imgs = [...sec.querySelectorAll('.dr-colors__img')];
      const name = sec.querySelector('[data-dr-name]');
      const price = sec.querySelector('[data-dr-price]');
      const idInput = sec.querySelector('input[name="id"]');
      const link = sec.querySelector('[data-dr-link]');
      const addBtn = sec.querySelector('[data-dr-add]');
      const pick = (i) => {
        const c = chips[i];
        chips.forEach((x, j) => x.setAttribute('aria-pressed', String(j === i)));
        imgs.forEach((x, j) => x.classList.toggle('is-on', j === i));
        sec.style.setProperty('--dr-c', c.dataset.glow);
        if (name) name.textContent = c.dataset.name;
        if (price) price.innerHTML = c.dataset.price;
        if (idInput) idInput.value = c.dataset.id;
        if (link) link.href = c.dataset.url;
        if (addBtn) { const ok = c.dataset.available === 'true'; addBtn.disabled = !ok; addBtn.querySelector('span').textContent = ok ? addBtn.dataset.labelAdd : addBtn.dataset.labelSold; }
      };
      chips.forEach((c, i) => c.addEventListener('click', () => pick(i)));
      const vid = new URLSearchParams(location.search).get('variant');
      const start = vid ? chips.findIndex((c) => c.dataset.id === vid) : -1;
      pick(start > -1 ? start : 0);
    });
  }

  /* Animacje przy przewijaniu: nagłówki słowo po słowie, elementy sekcji po kolei. Tylko poniżej pierwszego ekranu. */
  const ANIM_SKIP = '.dr-header, .dr-drawer, .dr-hero, dialog, [hidden]';
  const ANIM_ITEMS = '.dr-eyebrow, .dr-lead, .dr-card, .dr-tabs, .dr-modes__media, .dr-colors__stage, .dr-chips, .dr-box__img, .dr-box__item, .dr-faq__item, .dr-cta__box, .dr-btn, .dr-ghost';
  function splitWords(h) {
    if (h.dataset.drSplit) return;
    h.dataset.drSplit = '1';
    let n = 0;
    const wrap = (node) => {
      [...node.childNodes].forEach((c) => {
        if (c.nodeType === 3) {
          const parts = c.textContent.split(/(\s+)/);
          if (parts.every((p) => !p.trim())) return;
          const frag = document.createDocumentFragment();
          parts.forEach((p) => {
            if (!p) return;
            if (!p.trim()) { frag.appendChild(document.createTextNode(p)); return; }
            const w = document.createElement('span'); w.className = 'dr-w';
            const i = document.createElement('span'); i.className = 'dr-w__i'; i.style.setProperty('--i', n++); i.textContent = p;
            w.appendChild(i); frag.appendChild(w);
          });
          c.replaceWith(frag);
        } else if (c.nodeType === 1) {
          if (c.classList.contains('dr-grad-text')) {
            const w = document.createElement('span'); w.className = 'dr-w';
            c.replaceWith(w); w.appendChild(c); c.classList.add('dr-w__i'); c.style.setProperty('--i', n++);
          } else if (c.tagName !== 'BR') wrap(c);
        }
      });
    };
    wrap(h);
  }
  function initAnimations(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    const below = (el) => el.getBoundingClientRect().top > innerHeight * 0.9;
    const io = new IntersectionObserver((ents) => {
      ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    root.querySelectorAll('.dr-h2').forEach((h) => {
      if (h.closest(ANIM_SKIP) || h.dataset.drAnim || !below(h)) return;
      h.dataset.drAnim = '1'; splitWords(h); h.classList.add('dr-anim-words'); io.observe(h);
    });
    const groups = new Map();
    root.querySelectorAll(ANIM_ITEMS).forEach((el) => {
      if (el.dataset.drAnim || el.closest(ANIM_SKIP) || el.closest('.dr-anim') || !below(el)) return;
      el.dataset.drAnim = '1'; el.classList.add('dr-anim');
      const k = el.parentElement; const idx = groups.get(k) || 0; groups.set(k, idx + 1);
      el.style.setProperty('--d', Math.min(idx, 6) * 80 + 'ms');
      io.observe(el);
    });
  }

  /* „Kup teraz”: gdy Shopify pokazuje zwykły „Buy it now” (bez Apple Pay / Google Pay), dajemy własny przycisk w stylu sklepu
     → /cart/WARIANT:ILOŚĆ (od razu kasa). Przyciski portfeli zostają oryginalne. */
  const BUY_LABEL = { pl: 'Kup teraz', en: 'Buy it now', de: 'Jetzt kaufen', cs: 'Koupit hned', sk: 'Kúpiť teraz' };
  function syncBuyNow() {
    document.querySelectorAll('shopify-accelerated-checkout').forEach((sac) => {
      const host = sac.closest('.shopify-payment-button') || sac;
      const unbranded = !!sac.querySelector('shopify-buy-it-now-button');
      let btn = host.nextElementSibling && host.nextElementSibling.classList.contains('dr-buynow') ? host.nextElementSibling : null;
      if (!unbranded) { host.classList.remove('dr-pb-hidden'); if (btn) btn.remove(); return; }
      host.classList.add('dr-pb-hidden');
      if (btn) return;
      btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'dr-buynow';
      const lang = (document.documentElement.lang || 'pl').slice(0, 2);
      btn.textContent = BUY_LABEL[lang] || BUY_LABEL.pl;
      btn.addEventListener('click', () => {
        const form = host.closest('form') || document.querySelector('form[action*="/cart/add"]');
        const id = form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
        if (!id) return;
        const q = form.querySelector('input[name="quantity"]') || document.querySelector('quantity-selector-component input');
        const qty = Math.max(1, parseInt(q && q.value, 10) || 1);
        btn.classList.add('is-busy');
        location.assign(`${ROOT()}cart/${id}:${qty}` + (window.__drCode ? `?discount=${encodeURIComponent(window.__drCode)}` : ""));
      });
      host.after(btn);
    });
  }
  /* Kafelki kolorów na stronie produktu: miniatura drona w danym kolorze (zdjęcie wariantu z /products/…js)
     + „Kolor: Biały” w nagłówku. Horizon przerysowuje wybór wariantu, więc odświeżamy po każdej zmianie DOM. */
  let thumbs = null, thumbsLoading = false;
  function syncColorTiles() {
    const sets = document.querySelectorAll('.variant-option--buttons');
    if (!sets.length) return;
    const m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!thumbs && !thumbsLoading && m) {
      thumbsLoading = true;
      fetch(ROOT() + 'products/' + m[1] + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((p) => {
          thumbs = {};
          (p.variants || []).forEach((v) => { const src = v.featured_image && v.featured_image.src; if (src) thumbs[(v.option1 || '').toLowerCase()] = src + (src.includes('?') ? '&' : '?') + 'width=240'; });
          syncColorTiles();
        })
        .catch(() => { thumbs = {}; });
    }
    sets.forEach((fs) => {
      fs.querySelectorAll('.variant-option__button-label').forEach((l) => {
        const inp = l.querySelector('input');
        const src = thumbs && inp && thumbs[(inp.value || '').toLowerCase()];
        if (src && l.dataset.drThumb !== src) { l.style.setProperty('--dr-thumb', `url("${src}")`); l.dataset.drThumb = src; }
      });
      const lg = fs.querySelector('legend');
      const on = fs.querySelector('input:checked');
      if (lg && on) {
        let sp = lg.querySelector('.dr-sel');
        if (!sp) {
          if (lg.firstChild && lg.firstChild.nodeType === 3) lg.firstChild.textContent = lg.firstChild.textContent.trim();
          sp = document.createElement('span'); sp.className = 'dr-sel'; lg.append(': ', sp);
        }
        if (sp.textContent !== on.value) sp.textContent = on.value;
      }
    });
  }

  let buyRaf = 0;
  new MutationObserver((recs) => {
    if (recs.every((r) => r.target.closest && r.target.closest('[data-dr-drive], .dr-ticker, .dr-scratch'))) return;
    cancelAnimationFrame(buyRaf);
    buyRaf = requestAnimationFrame(() => { syncBuyNow(); syncColorTiles(); syncStickyH(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Mini-tor: dron prowadzony palcem / kursorem. W trybie DRIFT fizyka auta z małą przyczepnością boczną — ostry skręt
     = poślizg, ślady opon, dym i punkty (rekord w localStorage). W trybie LOT unosi się nad torem i płynie bez poślizgu.
     Gdy nikt nie steruje, jeździ ósemki sam (bez punktów). Pętla działa tylko, gdy tor jest widoczny. */
  function initDrive(root) {
    root.querySelectorAll('[data-dr-drive]').forEach((sec) => {
      if (sec.dataset.drReady) return;
      sec.dataset.drReady = '1';
      const track = sec.querySelector('[data-dr-track]');
      const cv = sec.querySelector('[data-dr-canvas]');
      const tc = sec.querySelector('[data-dr-trail]');
      if (!track || !cv || !tc) return;
      const ctx = cv.getContext('2d');
      const tx = tc.getContext('2d');
      const elScore = sec.querySelector('[data-dr-score]');
      const elBest = sec.querySelector('[data-dr-best]');
      const combo = sec.querySelector('[data-dr-combo]');
      const hint = sec.querySelector('[data-dr-hint]');
      const modeBar = sec.querySelector('.dr-drive__modes');
      const KEY = 'dr-drift-best';
      const store = {
        get: () => { try { return parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; } },
        set: (v) => { try { localStorage.setItem(KEY, String(v)); } catch (e) {} },
      };
      let best = store.get();
      if (elBest) elBest.textContent = best;
      const img = new Image();
      let imgOk = false;
      if (track.dataset.sprite) { img.onload = () => { imgOk = true; }; img.src = track.dataset.sprite; }
      const spriteAng = ((parseFloat(track.dataset.spriteAngle) || 0) * Math.PI) / 180;
      const CONES = [[0.2, 0.34], [0.8, 0.34], [0.5, 0.56], [0.2, 0.78], [0.8, 0.78]];

      let W = 0, H = 0, dpr = 1;
      const S = { x: 0, y: 0, vx: 0, vy: 0, h: -Math.PI / 2, z: 0, mode: 'drift' };
      let target = null, pointer = false, mouseIn = false, lastInput = -1e9;
      let score = 0, run = 0, shown = -1, raf = 0, t0 = 0, visible = false, comboTimer = 0;
      let prevL = null, prevR = null;
      const puffs = [];
      const size = () => Math.max(84, Math.min(150, Math.min(W, H) * 0.27));

      const resize = () => {
        const r = track.getBoundingClientRect();
        if (!r.width || !r.height || r.height > 1400) return; // bez stylów tor nie ma wysokości — nie rośnij w nieskończoność
        dpr = Math.min(2, window.devicePixelRatio || 1);
        W = r.width; H = r.height;
        [cv, tc].forEach((c) => { c.width = Math.round(W * dpr); c.height = Math.round(H * dpr); });
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        tx.setTransform(dpr, 0, 0, dpr, 0, 0);
        if (!S.x) { S.x = W / 2; S.y = H * 0.62; }
        prevL = prevR = null;
      };

      const pos = (e) => { const r = track.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
      const touched = () => { lastInput = performance.now(); };
      // Telefon: do pierwszego dotknięcia tor przepuszcza przewijanie strony (touch-action: pan-y); po dotknięciu („uzbrojony”)
      // przejmuje palec w całości. Gdy tor zniknie z ekranu — znowu przepuszcza przewijanie.
      const arm = (on) => { track.classList.toggle('is-armed', on); if (on && hint) hint.classList.add('is-off'); };
      track.addEventListener('pointerdown', (e) => {
        pointer = true; target = pos(e); touched();
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });
      track.addEventListener('pointermove', (e) => {
        if (e.pointerType === 'mouse') { mouseIn = true; target = pos(e); touched(); hint && hint.classList.add('is-off'); } else if (pointer) { target = pos(e); touched(); }
      });
      // uzbrojenie dopiero po skończonym dotyku (stuknięcie albo przeciągnięcie w bok) — przewijanie przez tor kończy się pointercancel i nie uzbraja
      let disarmT = 0;
      track.addEventListener('pointerup', (e) => {
        pointer = false;
        if (e.pointerType !== 'mouse') { arm(true); clearTimeout(disarmT); disarmT = setTimeout(() => { if (!pointer) arm(false); }, 2500); }
      });
      track.addEventListener('pointerdown', () => clearTimeout(disarmT));
      track.addEventListener('pointercancel', () => { pointer = false; });
      track.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { mouseIn = false; } });

      const setMode = (m) => {
        S.mode = m;
        if (modeBar) {
          modeBar.dataset.active = m === 'fly' ? '0' : '1';
          modeBar.querySelectorAll('[data-dr-mode]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.drMode === m)));
        }
        prevL = prevR = null;
        bank();
      };
      modeBar?.querySelectorAll('[data-dr-mode]').forEach((b) => b.addEventListener('click', () => setMode(b.dataset.drMode)));

      const showCombo = (txt, hold) => {
        if (!combo) return;
        if (combo.textContent !== txt) combo.textContent = txt;
        combo.classList.add('is-on');
        clearTimeout(comboTimer);
        if (!hold) comboTimer = setTimeout(() => combo.classList.remove('is-on'), 900);
      };
      // koniec poślizgu: punkty z tego driftu doliczają się do wyniku
      const bank = () => {
        if (run > 12) {
          const pts = Math.round(run);
          score += pts;
          showCombo('+' + pts);
          if (score > best) { best = score; store.set(best); if (elBest) elBest.textContent = best; }
          if (score >= 400) document.dispatchEvent(new CustomEvent('dr:drift-record', { detail: { score } }));
        } else if (combo) combo.classList.remove('is-on');
        run = 0;
      };

      const marks = (c, s, slip) => {
        const sz = size();
        const bx = S.x - c * sz * 0.26, by = S.y - s * sz * 0.26;
        const ox = -s * sz * 0.17, oy = c * sz * 0.17;
        const L = { x: bx + ox, y: by + oy }, R = { x: bx - ox, y: by - oy };
        if (prevL && prevR) {
          tx.strokeStyle = `rgba(16, 30, 70, ${Math.min(0.32, slip / 14).toFixed(3)})`;
          tx.lineWidth = 4; tx.lineCap = 'round';
          tx.beginPath(); tx.moveTo(prevL.x, prevL.y); tx.lineTo(L.x, L.y); tx.moveTo(prevR.x, prevR.y); tx.lineTo(R.x, R.y); tx.stroke();
        }
        prevL = L; prevR = R;
        if (puffs.length < 40 && Math.random() < 0.35) {
          const p = Math.random() < 0.5 ? L : R;
          puffs.push({ x: p.x, y: p.y, vx: (Math.random() - 0.5) * 0.5 - S.vx * 0.04, vy: (Math.random() - 0.5) * 0.5 - S.vy * 0.04, r: 3 + Math.random() * 4, life: 1 });
        }
      };

      const step = (dt, now) => {
        let tgt = mouseIn || pointer || now - lastInput < 2500 ? target : null;
        const auto = !reduce && !pointer && !mouseIn && now - lastInput > 3000;
        if (auto) {
          const t = (now / 1000) * 0.62;
          tgt = { x: W / 2 + Math.sin(t) * W * 0.33, y: H * 0.56 + Math.sin(2 * t) * H * 0.24 };
        }
        const fly = S.mode === 'fly';
        S.z += ((fly ? 1 : 0) - S.z) * Math.min(1, 0.07 * dt);
        if (tgt) {
          const dx = tgt.x - S.x, dy = tgt.y - S.y, d = Math.hypot(dx, dy);
          if (d > 16) {
            let diff = Math.atan2(dy, dx) - S.h;
            diff = Math.atan2(Math.sin(diff), Math.cos(diff));
            const turn = (fly ? 0.075 : 0.12) * dt;
            S.h += Math.max(-turn, Math.min(turn, diff));
            const thr = Math.min(d / 150, 1) * (fly ? 0.4 : 0.62) * (1 - (Math.min(Math.abs(diff), Math.PI) / Math.PI) * 0.45);
            S.vx += Math.cos(S.h) * thr * dt;
            S.vy += Math.sin(S.h) * thr * dt;
          }
        }
        const c = Math.cos(S.h), s = Math.sin(S.h);
        let f = S.vx * c + S.vy * s;
        let l = -S.vx * s + S.vy * c;
        f *= Math.pow(fly ? 0.95 : 0.966, dt);
        l *= Math.pow(fly ? 0.86 : 0.935, dt); // mała przyczepność boczna = poślizg
        S.vx = f * c - l * s; S.vy = f * s + l * c;
        const sp = Math.hypot(S.vx, S.vy), max = fly ? 8.5 : 11;
        if (sp > max) { S.vx *= max / sp; S.vy *= max / sp; }
        S.x += S.vx * dt; S.y += S.vy * dt;
        const m = size() * 0.48;
        if (S.x < m) { S.x = m; S.vx = Math.abs(S.vx) * 0.4; }
        if (S.x > W - m) { S.x = W - m; S.vx = -Math.abs(S.vx) * 0.4; }
        if (S.y < m) { S.y = m; S.vy = Math.abs(S.vy) * 0.4; }
        if (S.y > H - m) { S.y = H - m; S.vy = -Math.abs(S.vy) * 0.4; }
        const slip = Math.abs(l);
        const drifting = !fly && S.z < 0.2 && slip > 1.5 && sp > 3;
        if (drifting) {
          marks(c, s, slip);
          if (!auto) { run += slip * dt * 0.5; if (run > 12) showCombo('Drift +' + Math.round(run), true); }
        } else {
          prevL = prevR = null;
          if (run > 0) bank();
        }
      };

      let fadeAcc = 0;
      const fade = (dt) => {
        fadeAcc += 0.012 * dt;
        if (fadeAcc < 0.15) return; // rzadziej, ale mocniej — inaczej ślad utyka na ~16% krycia
        tx.save();
        tx.setTransform(1, 0, 0, 1, 0, 0);
        tx.globalCompositeOperation = 'destination-out';
        tx.fillStyle = `rgba(0, 0, 0, ${Math.min(1, fadeAcc).toFixed(3)})`;
        tx.fillRect(0, 0, tc.width, tc.height);
        tx.restore();
        fadeAcc = 0;
      };

      const draw = (now) => {
        ctx.clearRect(0, 0, W, H);
        // pachołki
        CONES.forEach(([px, py]) => {
          const x = px * W, y = py * H;
          ctx.fillStyle = 'rgba(12, 24, 56, .10)'; ctx.beginPath(); ctx.ellipse(x + 3, y + 5, 11, 6, 0, 0, 6.283); ctx.fill();
          ctx.fillStyle = '#046DF7'; ctx.beginPath(); ctx.moveTo(x, y - 14); ctx.lineTo(x + 9, y + 5); ctx.lineTo(x - 9, y + 5); ctx.closePath(); ctx.fill();
          ctx.fillStyle = '#fff'; ctx.fillRect(x - 5, y - 4, 10, 3);
        });
        // dym
        for (let i = puffs.length - 1; i >= 0; i--) {
          const p = puffs[i];
          p.x += p.vx; p.y += p.vy; p.r += 0.32; p.life -= 0.03;
          if (p.life <= 0) { puffs.splice(i, 1); continue; }
          ctx.fillStyle = `rgba(160, 175, 205, ${(0.2 * p.life).toFixed(3)})`;
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
        }
        const sz = size(), z = S.z, bob = z * Math.sin(now / 240) * 3;
        // cień (w locie dalej i jaśniejszy)
        ctx.save();
        ctx.translate(S.x + z * 16, S.y + z * 30 + sz * 0.04);
        ctx.rotate(S.h);
        ctx.fillStyle = `rgba(12, 24, 56, ${(0.2 - z * 0.1).toFixed(3)})`;
        ctx.beginPath(); ctx.ellipse(0, 0, sz * (0.42 - z * 0.08), sz * (0.3 - z * 0.06), 0, 0, 6.283); ctx.fill();
        ctx.restore();
        // wskaźnik celu
        if (target && (pointer || mouseIn)) {
          ctx.strokeStyle = 'rgba(4, 109, 247, .45)'; ctx.lineWidth = 2;
          ctx.beginPath(); ctx.arc(target.x, target.y, 14 + Math.sin(now / 150) * 2, 0, 6.283); ctx.stroke();
        }
        // dron
        ctx.save();
        ctx.translate(S.x, S.y - z * 20 + bob);
        ctx.rotate(S.h - spriteAng);
        const sc = 1 + z * 0.14;
        ctx.scale(sc, sc);
        if (imgOk) {
          const w = sz, h = (sz * img.naturalHeight) / img.naturalWidth;
          ctx.drawImage(img, -w / 2, -h / 2, w, h);
        } else {
          ctx.rotate(spriteAng);
          ctx.fillStyle = '#046DF7';
          ctx.beginPath(); ctx.moveTo(sz * 0.4, 0); ctx.lineTo(-sz * 0.3, sz * 0.22); ctx.lineTo(-sz * 0.3, -sz * 0.22); ctx.closePath(); ctx.fill();
        }
        ctx.restore();
      };

      const hud = () => {
        const v = score + (run > 12 ? Math.round(run) : 0);
        if (v !== shown && elScore) { elScore.textContent = v; shown = v; }
      };

      const tick = (now) => {
        const dt = t0 ? Math.max(0.2, Math.min(3, (now - t0) / 16.7)) : 1;
        t0 = now;
        if (W && H) { step(dt, now); fade(dt); draw(now); hud(); }
      };
      const loop = (now) => {
        tick(now);
        raf = visible && !document.hidden ? requestAnimationFrame(loop) : 0;
      };
      track._dr = { tick, S, get score() { return score; }, get run() { return run; } }; // do testów w konsoli
      const start = () => { if (!raf && visible && !document.hidden) { t0 = 0; raf = requestAnimationFrame(loop); } };
      if ('ResizeObserver' in window) new ResizeObserver(resize).observe(track);
      resize();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => { visible = en.isIntersecting; if (!visible) arm(false); start(); }, { threshold: 0.05 }).observe(track);
      } else { visible = true; start(); }
      document.addEventListener('visibilitychange', start);
    });
  }

  /* Zdrapka: srebrna „folia” na <canvas>, zdrapywana palcem / myszką (destination-out). Po zdrapaniu ~45% folia znika,
     pokazuje się kod, wybuch niebieskich iskier i przyciski. Stan w localStorage: odkryta karta zostaje odkryta. */
  /* Kod rabatowy ze zdrapki: Shopify zapamiętuje go w ciasteczku (/discount/KOD) i sam nalicza w kasie. */
  function applyCode(code) {
    if (!code) return;
    window.__drCode = code;
    document.documentElement.classList.add('dr-has-code');
    let done = false;
    try { done = sessionStorage.getItem('dr-kod-naliczony') === code; } catch (e) {}
    if (done) return;
    fetch(ROOT() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' })
      .then(() => { try { sessionStorage.setItem('dr-kod-naliczony', code); } catch (e) {} })
      .catch(() => {});
  }

  /* Pasek oferty pod ceną otwiera zdrapkę. */
  document.addEventListener('click', (e) => {
    if (!e.target.closest || !e.target.closest('[data-dr-offer-open]')) return;
    const pill = document.querySelector('[data-dr-scratch-open]');
    if (pill) pill.click();
  });

  /* „#kup” (mini-tor / wezwanie na stronie produktu): płynnie do wyboru koloru zamiast przeładowania strony. */
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href="#kup"]');
    if (!a) return;
    const t = document.querySelector('.variant-option--buttons') || document.querySelector('.product-details');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    t.classList.remove('dr-flash'); void t.offsetWidth; t.classList.add('dr-flash');
  });

  function initScratch(root) {
    root.querySelectorAll('[data-dr-scratch]').forEach((box) => {
      if (box.dataset.drReady) return;
      box.dataset.drReady = '1';
      const KEY = 'dr-zdrapka-' + (box.dataset.code || 'kod');
      const ls = {
        get: () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } },
        set: (v) => { try { localStorage.setItem(KEY, v); } catch (e) {} },
      };
      const pill = box.querySelector('[data-dr-scratch-open]');
      const modal = box.querySelector('[data-dr-scratch-modal]');
      const foil = box.querySelector('[data-dr-scratch-foil]');
      const fx = box.querySelector('[data-dr-scratch-fx]');
      const card = box.querySelector('[data-dr-scratch-card]');
      const meter = box.querySelector('[data-dr-scratch-meter]');
      const actions = box.querySelector('[data-dr-scratch-actions]');
      const sub = box.querySelector('[data-dr-scratch-sub]');
      const copyBtn = box.querySelector('[data-dr-scratch-copy]');
      const fctx = foil.getContext('2d', { willReadFrequently: true });
      let W = 0, H = 0, dpr = 1, drawn = false, done = false, last = null, moves = 0, lastFocus = null;

      const paintFoil = () => {
        const r = card.getBoundingClientRect();
        if (!r.width) return;
        dpr = Math.min(2, window.devicePixelRatio || 1); W = r.width; H = r.height;
        foil.width = Math.round(W * dpr); foil.height = Math.round(H * dpr);
        fctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        fctx.globalCompositeOperation = 'source-over';
        // srebrno-niebieska folia z połyskiem
        const g = fctx.createLinearGradient(0, 0, W, H);
        g.addColorStop(0, '#C7D2E6'); g.addColorStop(0.35, '#EEF2FA'); g.addColorStop(0.55, '#B9C6DD'); g.addColorStop(0.8, '#E4EAF6'); g.addColorStop(1, '#AEBBD4');
        fctx.fillStyle = g; fctx.fillRect(0, 0, W, H);
        // drobny „brokat”
        for (let i = 0; i < (W * H) / 60; i++) {
          fctx.fillStyle = Math.random() < 0.5 ? 'rgba(255,255,255,.55)' : 'rgba(90,110,150,.18)';
          fctx.fillRect(Math.random() * W, Math.random() * H, 1.2, 1.2);
        }
        // ślady opon (drift) na folii
        fctx.strokeStyle = 'rgba(40, 56, 96, .22)'; fctx.lineWidth = 7; fctx.lineCap = 'round';
        [[0.08, 0.9, 0.55, 0.15, 0.95, 0.55], [0.14, 0.98, 0.6, 0.24, 1.02, 0.66]].forEach(([x0, y0, cx, cy, x1, y1]) => {
          fctx.beginPath(); fctx.moveTo(x0 * W, y0 * H); fctx.quadraticCurveTo(cx * W, cy * H, x1 * W, y1 * H); fctx.stroke();
        });
        // napis
        const u = Math.min(W, H * 1.6);
        fctx.fillStyle = 'rgba(10, 13, 20, .78)';
        fctx.textAlign = 'center'; fctx.textBaseline = 'middle';
        fctx.font = `italic 700 ${Math.round(u * 0.11)}px "DRION Display", "Chakra Petch", sans-serif`;
        fctx.fillText((foil.dataset.label || 'Zdrap tutaj').toUpperCase(), W / 2, H / 2 - 6);
        fctx.font = `600 ${Math.round(u * 0.045)}px system-ui, sans-serif`;
        fctx.fillStyle = 'rgba(10, 13, 20, .5)';
        fctx.fillText('← palcem albo myszką →', W / 2, H / 2 + u * 0.09);
        drawn = true;
      };

      // iskry po odkryciu
      const burst = () => {
        const r = card.getBoundingClientRect();
        const c = fx.getContext('2d');
        fx.width = Math.round(r.width * dpr); fx.height = Math.round(r.height * dpr);
        c.setTransform(dpr, 0, 0, dpr, 0, 0);
        const cols = ['#046DF7', '#2F8BFF', '#3CD3FF', '#0A0D14', '#FFFFFF'];
        const parts = Array.from({ length: 70 }, () => {
          const a = Math.random() * Math.PI * 2, v = 3 + Math.random() * 6;
          return { x: r.width / 2, y: r.height / 2, vx: Math.cos(a) * v, vy: Math.sin(a) * v - 2, w: 4 + Math.random() * 6, h: 2 + Math.random() * 3, rot: Math.random() * 6, vr: (Math.random() - 0.5) * 0.4, col: cols[(Math.random() * cols.length) | 0], life: 1 };
        });
        const tick = () => {
          c.clearRect(0, 0, r.width, r.height);
          let alive = 0;
          parts.forEach((p) => {
            if (p.life <= 0) return;
            alive++;
            p.x += p.vx; p.y += p.vy; p.vy += 0.18; p.vx *= 0.985; p.rot += p.vr; p.life -= 0.014;
            c.save(); c.globalAlpha = Math.max(0, p.life); c.translate(p.x, p.y); c.rotate(p.rot); c.fillStyle = p.col; c.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); c.restore();
          });
          if (alive) requestAnimationFrame(tick); else c.clearRect(0, 0, r.width, r.height);
        };
        requestAnimationFrame(tick);
      };

      const mailStep = box.querySelector('[data-dr-scratch-mail]');
      const received = () => ls.get() === 'odebrany';
      // krok 3: kod widoczny, rabat naliczany
      const showCode = () => {
        box.classList.add('is-code');
        if (mailStep) mailStep.hidden = true;
        actions.hidden = false;
        if (sub) { sub.setAttribute('role', 'status'); if (sub.dataset.done) sub.textContent = sub.dataset.done; }
        ls.set('odebrany');
        applyCode(box.dataset.code);
      };
      const reveal = (instant) => {
        if (done) return;
        done = true;
        box.classList.add('is-done');
        foil.tabIndex = -1; foil.setAttribute('aria-hidden', 'true');
        if (received()) showCode();
        else {
          ls.set('odkryta');
          if (mailStep) mailStep.hidden = false;
          if (sub) { sub.setAttribute('role', 'status'); if (sub.dataset.mail) sub.textContent = sub.dataset.mail; }
          if (!instant) setTimeout(() => mailStep?.querySelector('input[type="email"]')?.focus({ preventScroll: true }), 450);
        }
        if (!instant && !reduce) burst();
        if (!instant && navigator.vibrate) try { navigator.vibrate([12, 40, 18]); } catch (e) {}
      };

      // ile folii zdrapane (próbka co 6 px)
      const progress = () => {
        const d = fctx.getImageData(0, 0, foil.width, foil.height).data;
        let clear = 0, all = 0;
        const st = Math.max(1, Math.round(6 * dpr));
        for (let y = 0; y < foil.height; y += st) for (let x = 0; x < foil.width; x += st) { all++; if (d[(y * foil.width + x) * 4 + 3] < 40) clear++; }
        return all ? clear / all : 0;
      };

      const scratch = (x, y) => {
        if (done) return;
        fctx.globalCompositeOperation = 'destination-out';
        fctx.lineWidth = Math.max(34, W * 0.11); fctx.lineCap = 'round'; fctx.lineJoin = 'round';
        fctx.beginPath();
        if (last) { fctx.moveTo(last.x, last.y); fctx.lineTo(x, y); } else { fctx.moveTo(x, y); fctx.lineTo(x + 0.1, y); }
        fctx.stroke();
        last = { x, y };
        if (++moves % 6 === 0) {
          const p = progress();
          if (meter) meter.style.width = Math.min(100, Math.round((p / 0.45) * 100)) + '%';
          if (p > 0.45) reveal();
          if (moves % 18 === 0 && navigator.vibrate) try { navigator.vibrate(4); } catch (e) {}
        }
      };
      const at = (e) => { const r = foil.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
      let down = false;
      foil.addEventListener('pointerdown', (e) => { down = true; last = null; try { foil.setPointerCapture(e.pointerId); } catch (err) {} const p = at(e); scratch(p.x, p.y); });
      foil.addEventListener('pointermove', (e) => { if (!down) return; const p = at(e); scratch(p.x, p.y); });
      ['pointerup', 'pointercancel'].forEach((t) => foil.addEventListener(t, () => { down = false; last = null; }));
      // klawiatura: Enter / spacja na karcie odkrywa od razu
      foil.tabIndex = 0;
      foil.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); reveal(); } });

      const open = () => {
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.documentElement.classList.add('dr-scratch-open');
        document.documentElement.toggleAttribute('scroll-lock', true);
        if (!drawn && !done) requestAnimationFrame(() => {
          paintFoil();
          if (document.fonts && document.fonts.load) document.fonts.load('italic 700 30px "DRION Display"').then(() => { if (!done && moves === 0) paintFoil(); }).catch(() => {});
        });
        if (!ls.get()) ls.set('otwarta');
        setTimeout(() => { const f = !done ? foil : received() ? actions.querySelector('a, button') : mailStep?.querySelector('input[type="email"]'); if (f) f.focus({ preventScroll: true }); }, 60);
      };
      const close = () => {
        modal.hidden = true;
        document.documentElement.classList.remove('dr-scratch-open');
        document.documentElement.removeAttribute('scroll-lock');
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      };
      pill.addEventListener('click', open);
      box.querySelectorAll('[data-dr-scratch-close]').forEach((b) => b.addEventListener('click', close));
      modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') { // fokus zostaje w oknie
          const f = [...modal.querySelectorAll('button, a[href], input, [tabindex="0"]')].filter((x) => x.offsetParent);
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
        }
      });
      copyBtn?.addEventListener('click', () => {
        const code = box.dataset.code || '';
        const ok = () => { copyBtn.textContent = copyBtn.dataset.done || 'Skopiowano'; };
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(ok).catch(() => {});
        else { const t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); ok(); } catch (e) {} t.remove(); }
      });

      const result = box.querySelector('[data-dr-scratch-result]')?.dataset.drScratchResult || '';
      if (result === 'ok' || (/customer_posted=true/.test(location.search) && ls.get() === 'odkryta')) ls.set('odebrany');
      if (ls.get() === 'odkryta' || received()) reveal(true);
      document.addEventListener('dr:drift-record', () => {
        if (done) return;
        try { if (sessionStorage.getItem('dr-nagroda')) return; sessionStorage.setItem('dr-nagroda', '1'); } catch (e) {}
        const track = document.querySelector('[data-dr-track]');
        if (!track || track.querySelector('.dr-reward')) return;
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'dr-reward';
        b.textContent = 'Niezły drift! Odbierz nagrodę: −10%';
        b.addEventListener('click', (ev) => { ev.stopPropagation(); b.remove(); open(); });
        b.addEventListener('pointerdown', (ev) => ev.stopPropagation());
        track.appendChild(b);
      });
      pill.hidden = false;
      // po zapisie na newsletter strona się przeładowuje — otwieramy okno z wynikiem
      if (result) { reveal(true); open(); } // właśnie wysłany e-mail (albo błąd) → pokaż wynik
      const auto = parseInt(box.dataset.auto, 10) || 0;
      if (auto > 0 && !ls.get() && !(window.Shopify && Shopify.designMode)) setTimeout(() => { if (modal.hidden && !ls.get()) open(); }, auto * 1000);
      addEventListener('resize', () => { if (!done && !modal.hidden && moves === 0) paintFoil(); }, { passive: true });
    });
  }

  /* Wysokość przyklejonego paska „Dodaj do koszyka” → --dr-sticky-h (przycisk zdrapki ustawia się nad nim). */
  function syncStickyH() {
    const bar = document.querySelector('.sticky-add-to-cart__bar');
    if (bar && bar.offsetHeight) document.documentElement.style.setProperty('--dr-sticky-h', bar.offsetHeight + 'px');
  }
  addEventListener('resize', syncStickyH, { passive: true });
  addEventListener('scroll', syncStickyH, { passive: true });

  function init(root = document) {
    const r = root.querySelector ? root : document;
    initDrive(r);
    initScratch(r);
    initHeader(r);
    initSky();
    initTilt(r);
    initModes(r);
    initColors(r);
    initAnimations(r);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
